export enum AlertTriggerTiming {
  BEFORE = "BEFORE",
  AFTER = "AFTER",
  RECURRING = "RECURRING",
}
